/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React, { useRef, useState, useMemo } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { useGLTF, View, Environment } from '@react-three/drei';
import * as THREE from 'three';
export function CanModel3D({ color, hovered }) {
    const groupRef = useRef();
    const { scene } = useGLTF('/models/CanMiniCut-opt.glb');
    const targetY = hovered ? -1.8 : -2.1;
    const targetScale = hovered ? 12.15 : 12.0;
    const currentY = useRef(0.0);
    const currentScale = useRef(1.0);
    const clonedScene = useMemo(() => {
        if (!scene) return null;
        const cloned = scene.clone();
        cloned.traverse((child) => {
            if (child.isMesh) {
                if (child.name.toLowerCase().includes('color')) {
                    if (child.geometry) {
                        child.geometry.computeVertexNormals();
                    }
                    child.material = new THREE.MeshStandardMaterial({
                        color: new THREE.Color(color),
                        roughness: 0.35,
                        metalness: 0.1,
                        bumpScale: 0.05
                    });
                }
            }
        });
        const box = new THREE.Box3().setFromObject(cloned);
        const center = new THREE.Vector3();
        box.getCenter(center);
        const size = new THREE.Vector3();
        box.getSize(size);
        const wrapper = new THREE.Group();
        cloned.position.sub(center);
        wrapper.add(cloned);
        const maxDim = Math.max(size.x, size.y, size.z);
        if (maxDim > 0) {
            wrapper.scale.setScalar(3.6 / maxDim);
        }
        return wrapper;
    }, [scene, color]);
    useFrame((state, delta) => {
        if (groupRef.current) {
            currentY.current = THREE.MathUtils.lerp(currentY.current, targetY, 0.15);
            currentScale.current = THREE.MathUtils.lerp(currentScale.current, targetScale, 0.15);
            groupRef.current.position.y = currentY.current;
            groupRef.current.scale.setScalar(currentScale.current);
            if (hovered) {
                groupRef.current.rotation.y = (groupRef.current.rotation.y + delta * 0.5) % (Math.PI * 2);
                groupRef.current.rotation.x = THREE.MathUtils.lerp(groupRef.current.rotation.x, 0.15, 0.15);
            } else {
                groupRef.current.rotation.y = THREE.MathUtils.lerp(groupRef.current.rotation.y, 0.7, 0.15);
                groupRef.current.rotation.x = THREE.MathUtils.lerp(groupRef.current.rotation.x, 0.25, 0.15);
            }
        }
    });
    if (!clonedScene) return null;
    return <primitive ref={groupRef} object={clonedScene} />;
}
export function CanPickerItem({ colorObj, isSelected, onClick, zIndex }) {
    const [hovered, setHovered] = useState(false);
    return (
        <div
            className={`can-picker-item ${isSelected ? 'selected' : ''}`}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={onClick}
            style={{ zIndex }}
        >
            <View className="can-3d-wrapper" camera={{ position: [0, 0, 1.8], fov: 45 }}>
                <ambientLight intensity={1.5} />
                <directionalLight position={[2, 3, 2]} intensity={1.5} />
                <Environment preset="city" />
                <CanModel3D color={colorObj.hex} hovered={hovered} />
            </View>
            <div className="can-tooltip">
                {colorObj.name}
            </div>
        </div>
    );
}
export function CanPickerCanvas() {
    return (
        <Canvas
            style={{
                position: 'absolute',
                top: '76px',
                bottom: 0,
                left: '24px',
                right: '24px',
                pointerEvents: 'none',
                zIndex: 1000
            }}
        >
            <View.Port />
        </Canvas>
    );
}
useGLTF.preload('/models/CanMiniCut-opt.glb');
